<template>
  <div class="bill-details page" ref="container">
    <nav-bar
      title="服务记录"
      left-text="返回"
      left-arrow
      @click-left="goBack"
      :fixed="false"
      :placeholder="true"
    />

    <div class="nav acea-row">
      <div
        class="item"
        :class="types == -1 ? 'on' : ''"
        @click="changeTypes(-1)"
      >
        全部
      </div>
      <div class="item" :class="types == 0 ? 'on' : ''" @click="changeTypes(0)">
        待付款
      </div>
      <div class="item" :class="types == 1 ? 'on' : ''" @click="changeTypes(1)">
        待签字
      </div>
      <div class="item" :class="types == 2 ? 'on' : ''" @click="changeTypes(2)">
        待评价
      </div>
      <div class="item" :class="types == 3 ? 'on' : ''" @click="changeTypes(3)">
        已完成
      </div>
    </div>
    <div class="list-wrap my-order">
      <div class="list">
        <div
          class="item"
          v-for="order in list"
          :key="order.id"
          @click="$router.push({ path: `/order/detail/${order.id}` })"
        >
          <div class="title acea-row row-between-wrapper">
            <div class="acea-row row-middle">
              {{ formatDate(order.createTime) }}
            </div>
            <div class="top acea-row row-right row-middle font-color-red">
              {{ status[order.status] }}
            </div>
          </div>
          <div
            class="item-info acea-row row-between row-top"
            v-for="item in order.items"
            :key="item.id"
          >
            <div class="pictrue">
              <img
                src="@assets/images/def_service.jpg"
                v-if="!item.itemPic"
                class="no-picture"
              />
              <img :src="item.itemPic + '!tmb_130'" v-else />
            </div>
            <div>
              <div class="text acea-row row-between">
                <div class="name line2">{{ item.itemName }}</div>
                <div class="money">
                  <div>￥{{ item.price }}</div>
                  <div>x{{ item.num }}</div>
                </div>
              </div>
              <div class="text acea-row row-between">
                服务顾问：{{ item.waiterName }}
              </div>
            </div>
          </div>
          <div class="totalPrice">
            <span>共{{ order.items.length || 0 }}个项目</span>
            <div>
              总金额:
              <span class="money font-color-red"
                >￥{{ order.totalAmount }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="no-data" v-if="list.length === 0 && where.page > 1">
        <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getConsume } from "@api/member";
import { NavBar } from "vant";
import Loading from "@components/Loading";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  components: {
    Loading,
    NavBar,
  },
  props: {},
  data: function () {
    return {
      types: -1,
      where: {
        page: 1,
        limit: 5,
      },
      list: [],
      status: ["待付款", "待签字", "待评价", "已完成"],
      loaded: false,
      loading: false,
    };
  },
  watch: {
    userInfo: {
      handler(val, oldVal) {
        this.getIndex();
      },
    },
    types: function () {
      this.getIndex();
    },
  },
  computed: mapGetters(["userInfo"]),
  mounted: function () {
    let that = this;
    that.getIndex();
    that.$scroll(that.$refs.container, () => {
      !that.loading && that.getIndex();
    });
  },
  methods: {
    formatDate(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    changeTypes: function (val) {
      if (val != this.types) {
        this.types = val;
        this.list = [];
        this.where.page = 1;
        this.loaded = false;
        this.loading = false;
      }
    },
    getIndex: function () {
      let that = this;
      if (that.loaded == true || that.loading == true) return;
      if (this.types !== -1) {
        that.where.param = { status: this.types };
      }
      that.loading = true;
      getConsume(that.where).then((res) => {
        that.loading = false;
        that.loaded = res.result.total < that.where.limit;
        that.where.page = that.where.page + 1;
        that.list.push.apply(that.list, res.result.records);
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.list-wrap {
  .top .bnt {
    width: 1.76rem;
    height: 0.6rem;
    text-align: center;
    line-height: 0.6rem;
    color: #fff;
    border-radius: 0.5rem;
    font-size: 0.27rem;
  }
  .totalPrice {
    text-align: left;
    display: flex;
    justify-content: space-between;
    border-top: 0.01rem solid #eee;
    margin-top: 0.22rem !important;
    border-bottom: none !important;
    padding: 0.2rem 0.3rem 0.2rem !important;
  }

  .item-info {
    .pictrue {
      border: 1px solid #c3cbd6;
      border-radius: 0.06rem;
    }
  }
}
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 80px;

  .pictrue img {
    width: 207px;
    height: 160px;
  }
}
</style>
